const TacticCard = require("../../entities/Cards/TacticCard");
const Tactics = require("../../Constants/Tactics/Tactics");
const ByName = require("./ByName");

const classOf = ByName(Tactics);

const TacticConverter = (tacticName) =>
{
    const Class = classOf(tacticName);
    return Class === undefined ? null : new TacticCard(new Class());
}

module.exports = TacticConverter;
